var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonTooltip',{attrs:{"color":"warning","icon":"get_app","type":"download","tooltip":_vm.$t('adminVideo.buttons.downloadFile'),"disabled":_vm.disabled},on:{"event-click":_vm.downloadFile}})
}
var staticRenderFns = []

export { render, staticRenderFns }